import { GetDetailedSupplierQuery } from 'data/__generated__';

export function removeFieldNameFromOrderingTimeForDay(
    orderingDay:
        | GetDetailedSupplierQuery['detailedSupplier']['orderingTimes']['monday']
        | GetDetailedSupplierQuery['detailedSupplier']['orderingTimes']['tuesday']
        | GetDetailedSupplierQuery['detailedSupplier']['orderingTimes']['wednesday']
        | GetDetailedSupplierQuery['detailedSupplier']['orderingTimes']['thursday']
        | GetDetailedSupplierQuery['detailedSupplier']['orderingTimes']['friday']
        | GetDetailedSupplierQuery['detailedSupplier']['orderingTimes']['saturday']
        | GetDetailedSupplierQuery['detailedSupplier']['orderingTimes']['sunday'],
) {
    return {
        orderBefore: orderingDay.orderBefore,
        daysToDeliver: orderingDay.daysToDeliver,
        deliveryHours: {
            start: orderingDay.deliveryHours.start,
            end: orderingDay.deliveryHours.end,
        },
        canBeOrdered: orderingDay.canBeOrdered,
    };
}
